import { Fragment, useEffect, useState } from 'react';
import Dialog from '@mui/material/Dialog';
import Button from '@mui/material/Button';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import { useOutletContext } from 'react-router-dom';

const MpgConfirmDialogForAccAndSubAccount = ({ title, content, open, setOpen, actionType, handlerOnAccountOnlyActivation, handlerOnAllActivation, handlerOnDeactivation }) => {
    /**actionType = "ActivateAccount"|"DeactivateAccount"|"ActivateSubAccount"|"DeactivateSubAccount" */

    /**when actionType="ActivateAccount" |"ActivateSubAccount" then  handlerOnAccountOnlyActivation and handlerOnAllActivation are imp*/

    /**when actionType="DeactivateAccount"|"DeactivateSubAccount" then  handlerOnDeactivation is imp*/
    const { refClientAccountCmsData } = useOutletContext();
    const handleClose = (event, reason) => {
        if (reason && reason == "backdropClick") {
            return '';
        } else {
            setOpen(false);
        }
    };

    const callHandlerOnAccountOnlyActivation = () => {
        if (!!handlerOnAccountOnlyActivation) {
            handlerOnAccountOnlyActivation()
        }
        handleClose()
    }

    const callHandlerOnAllActivation = () => {
        if (!!handlerOnAllActivation) {
            handlerOnAllActivation()
        }
        handleClose()
    }

    const callHandlerOnDeactivation = () => {
        if (!!handlerOnDeactivation) {
            handlerOnDeactivation()
        }
        handleClose()
    }

    const fetchClientAccountCmsData = (key, isRichText) => {
        if (refClientAccountCmsData?.Components && refClientAccountCmsData?.Components["ClientAccountsPopUps"]) {
            const adminClientAccountCmsDataLabel = refClientAccountCmsData?.Components["ClientAccountsPopUps"];
            if (isRichText) {
                return returnRichText(adminClientAccountCmsDataLabel?.RichTexts, key);
            }
            return returnLabel(adminClientAccountCmsDataLabel?.Labels, key)
        }
        return '';
    }

    const returnRichText = (labelArray = [], key) => {
        return labelArray.find((x) => x.Key === key)?.Value || '';
    }

    const returnLabel = (labelArray = [], key) => {
        return labelArray.find((x) => x.Key === key)?.Phrase || '';
    }

    const [buttonNamesOnActivateAccOrSubAccOnly, setButtonNamesOnActivateAccOrSubAccOnly] = useState("")
    useEffect(() => {
        if (actionType === "ActivateAccount") {
            setButtonNamesOnActivateAccOrSubAccOnly(fetchClientAccountCmsData('ClientAccountsPopUps.ActivateAccount', false))
        }
        if (actionType === "ActivateSubAccount") {
            setButtonNamesOnActivateAccOrSubAccOnly(fetchClientAccountCmsData('ClientAccountsPopUps.ActivateSubAccount', false))
        }
    }, [actionType])

    const contentForDeactivation = (
        actionType === "DeactivateAccount" ? <div dangerouslySetInnerHTML={{ __html: fetchClientAccountCmsData('ClientAccountsPopUps.DeactivateClientAccount', true) }}></div > :
            <div dangerouslySetInnerHTML={{ __html: fetchClientAccountCmsData('ClientAccountsPopUps.DeactivateClientSubAccount', true) }}></div >
    )

    const contentForActivation = (
        actionType === "ActivateAccount" ? <div dangerouslySetInnerHTML={{ __html: fetchClientAccountCmsData('ClientAccountsPopUps.ReactivateClientAccount', true) }}></div > :
            <div dangerouslySetInnerHTML={{ __html: fetchClientAccountCmsData('ClientAccountsPopUps.ReactivateClientSubAccount', true) }}></div >
    )


    return (
        <div>
            <Dialog
                open={open}
                onClose={handleClose}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <DialogTitle id="alert-dialog-title">
                    {
                        !!title
                            ? title
                            : fetchClientAccountCmsData('ClientAccountsPopUps.ConfirmYourAction', false)
                    }
                </DialogTitle>
                <DialogContent>
                    <DialogContentText id="alert-dialog-description">
                        {
                            !!actionType && (actionType === "ActivateAccount" || actionType === "ActivateSubAccount") && (contentForActivation)
                        }
                        {
                            !!actionType && (actionType === "DeactivateAccount" || actionType === "DeactivateSubAccount") && (contentForDeactivation)
                        }
                    </DialogContentText>
                </DialogContent>

                {
                    !!actionType && (actionType === "ActivateAccount" || actionType === "ActivateSubAccount") ?

                        <DialogActions>
                            <Button
                                onClick={() => {
                                    callHandlerOnAccountOnlyActivation()
                                }}
                                autoFocus
                            >
                                {buttonNamesOnActivateAccOrSubAccOnly}
                            </Button>
                            <Button
                                onClick={() => {
                                    callHandlerOnAllActivation()
                                }}
                                autoFocus
                            >
                                {fetchClientAccountCmsData('ClientAccountsPopUps.ActivateAll', false)}
                            </Button>
                            <Button onClick={handleClose}>{fetchClientAccountCmsData('ClientAccountsPopUps.Cancel', false)}</Button>
                        </DialogActions>
                        :
                        <DialogActions>
                            <Button onClick={() => {
                                callHandlerOnDeactivation()
                            }}
                                autoFocus
                            >
                                {fetchClientAccountCmsData('ClientAccountsPopUps.Agree', false)}
                            </Button>
                            <Button onClick={handleClose}>{fetchClientAccountCmsData('ClientAccountsPopUps.Cancel', false)}</Button>
                        </DialogActions>
                }
            </Dialog>
        </div>
    )
}
export default MpgConfirmDialogForAccAndSubAccount